import React from 'react'
import UiContentCard from "../../../components/cards/UiContentCard"
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../../../components/grid-container/GridContainer"
import London from "../../../../../styles/img/favourites/london.jpg"
import Nike from "../../../../../styles/img/favourites/nike.jpg"
import Tokyo from "../../../../../styles/img/favourites/tokyo.jpg"

export default function LoyaltyStoreList(props) {

    const visit = () => {
    }
    return (
        <>
         <div className='sb-products-list-wr'>
            <UiSingleRow>
                <UiCol lg="3">
                    <UiContentCard
                        cardImg={Nike}
                        visit={visit}
                        heading="Nike"
                        body="From its medieval origins to the digital era, learn from its everything."
                    />
                </UiCol>
                <UiCol lg="3">
                    <UiContentCard
                        cardImg={Nike}
                        visit={visit}
                        heading="Nike"
                        body="From its medieval origins to the digital era, learn from its everything."
                    />
                </UiCol>
                <UiCol lg="3">
                    <UiContentCard
                        cardImg={Nike}
                        visit={visit}
                        heading="Nike"
                        body="From its medieval origins to the digital era, learn from its everything."
                    />
                </UiCol>
                <UiCol lg="3">
                    <UiContentCard
                        cardImg={Nike}
                        visit={visit}
                        heading="Nike"
                        body="From its medieval origins to the digital era, learn from its everything."
                    />
                </UiCol>
                <UiCol lg="3">
                    <UiContentCard
                        cardImg={Nike}
                        visit={visit}
                        heading="Nike"
                        body="From its medieval origins to the digital era, learn from its everything."
                    />
                </UiCol>
                <UiCol lg="3">
                    <UiContentCard
                        cardImg={Nike}
                        visit={visit}
                        heading="Nike"
                        body="From its medieval origins to the digital era, learn from its everything."
                    />
                </UiCol>
                <UiCol lg="3">
                    <UiContentCard
                        cardImg={Nike}
                        visit={visit}
                        heading="Nike"
                        body="From its medieval origins to the digital era, learn from its everything."
                    />
                </UiCol>
                <UiCol lg="3">
                    <UiContentCard
                        cardImg={Nike}
                        visit={visit}
                        heading="Nike"
                        body="From its medieval origins to the digital era, learn from its everything."
                    />
                </UiCol>
            </UiSingleRow>
            </div>
        </>
    )
}
